import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=6c60f713&"
import script from "./ChatMessages.vue?vue&type=script&lang=js&"
export * from "./ChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports